import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { Schemas } from "../../../types";
import { Key } from "react";
import { useTranslation } from "react-i18next";

type CustomQuestionnaireQuestionMenuProps = {
  type: "create" | "update";
  index: number;
  currentPriority: number;
  questions: Schemas["CustomQuestionnaireQuestionInput"][];
  handleQuestion: (input: {
    action: "moveUp" | "moveDown" | "duplicate" | "delete";
    questions: Schemas["CustomQuestionnaireQuestionInput"][];
    currentPriority: number;
  }) => void;
};

export const CustomQuestionnaireQuestionMenu = ({
  type,
  index,
  currentPriority,
  questions,
  handleQuestion,
}: CustomQuestionnaireQuestionMenuProps) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu
      triggerButton={
        <GhostIconButton
          size="small"
          icon="more_vert"
          testID={`question-menu-${index}`}
        />
      }
      placement="bottom right"
      testID={`question-menu-dropdown-${index}`}
      onItemAction={(key: Key) => {
        handleQuestion({
          action: key as "moveUp" | "moveDown" | "duplicate" | "delete",
          questions,
          currentPriority,
        });
      }}
    >
      <MenuItem
        id="moveUp"
        icon="arrow_upward"
        textStyle="input/text-field"
        isDisabled={currentPriority === 1 || type === "update"}
      >
        {t("Move up")}
      </MenuItem>
      <MenuItem
        id="moveDown"
        icon="arrow_downward"
        textStyle="input/text-field"
        isDisabled={currentPriority === questions.length || type === "update"}
      >
        {t("Move down")}
      </MenuItem>
      <MenuItem
        id="duplicate"
        icon="content_copy"
        textStyle="input/text-field"
        isDisabled={type === "update"}
      >
        {t("Duplicate")}
      </MenuItem>
      <MenuItem
        id="delete"
        icon="delete"
        textStyle="input/text-field"
        isDisabled={type === "update"}
      >
        {t("Delete")}
      </MenuItem>
    </DropdownMenu>
  );
};
